import { AreaChart } from "@msuite/ui/charts";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ClassNameProps } from "@msuite/ui/types";
import { formatNumber } from "@msuite/utils/numbers";
import type { IncomingInvoiceStatistics } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoicesReceivedTileProps extends ClassNameProps {
	receivedPerMonth: IncomingInvoiceStatistics["receivedPerMonth"];
}

export function IncomingInvoicesReceivedTile({
	className,
	receivedPerMonth,
}: IncomingInvoicesReceivedTileProps) {
	/** Context */
	const { t } = useTranslation();

	/** Computed */
	const data = receivedPerMonth.map(({ month, grossAmount }) => ({ name: month, grossAmount }));

	/** Render */
	return (
		<ContentCard
			title={t("incoming_invoices.received_per_month")}
			icon={icon("TrendingUp")}
			isCollapsible={false}
			className={className}
			contentClassName="h-72"
		>
			<AreaChart
				data={data}
				dataKeys={["grossAmount"]}
				displayKeyMap={{ grossAmount: t("incoming_invoices.gross_amount") }}
				formatter={(value) => formatNumber(value, "currency")}
				curveType="monotone"
				xAxisVisible
			/>
		</ContentCard>
	);
}
